package de.ohhhmhhh.backend.models.model.asset

import kotlinx.serialization.Serializable

@Serializable
enum class AssetTypeEntity {
    DIRECTORY, AUDIO, VIDEO, IMAGE, OTHER;
}